import { Undo2 } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

const StoreReturnBtn = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from;

  return (
    <div className="">
      <button
        className="border flex gap-2 items-center px-4 py-2 text-sm rounded-full transition-all ease-in-out duration-300 hover:bg-[#402430] hover:text-white cursor-pointer"
        onClick={() => {
          setTimeout(() => {
            navigate(from || "/conciliacao/lojas");
          });
        }}
      >
        <Undo2 size={18} />
        {typeof from === "string" &&
        (from === "/conciliacao/gerenciar-perdas" ||
          from.startsWith("/conciliacao/gerenciar-perdas/"))
          ? "Voltar para Gerenciar Perdas e Faltas"
          : from === "/conciliacao/faltas-de-conciliacoes"
            ? "Voltar para Faltas de Conciliação"
            : from === "/conciliacao/lojas"
              ? "Voltar para Lojas"
              : "Ir para Lojas"}
      </button>
    </div>
  );
};

export default StoreReturnBtn;
